/* 劉備傳・第 6 章：當陽長坂（208 年）
 * 北邊是潰散的劉備軍與百姓，曹純的虎豹騎從北面追來。南邊一條河，大路上有一座橋（長坂橋）；張飛在南岸據水斷橋。 */
export const RIVER_Y = 3700, BRIDGE = [4000, 3700], SOUTH = [4000, 4400], REFUGE = [[2300, 1500], [5700, 1300], [2900, 2700], [5300, 2600]];
export default {
  id: 'changban', name: '長坂', W: 8000, H: 5200, seed: 2085,
  bases: [[4000, 900], SOUTH],
  rivers: [{ pts: [[-100, RIVER_Y + 30], [2500, RIVER_Y - 20], [5500, RIVER_Y + 20], [8100, RIVER_Y - 10]], hw: 230, fords: [[2900, 3720, 200], [5100, 3720, 200]] }], // 橋兩邊各有一處淺水，曹兵膽氣回升時會從這裡涉水
  roads: [{ pts: [[4000, 600], [4100, 1800], [3900, 2900], BRIDGE, SOUTH, [4000, 5000]], w: 160 }, { pts: [[4100, 1800], REFUGE[0]], w: 90 }, { pts: [[4100, 1800], REFUGE[1]], w: 90 }],
  rocks: [[1500, 2300, 420, 200], [6500, 2300, 420, 200], [1300, 4500, 420, 200], [6700, 4500, 420, 200]],
  woods: 0.35,
  sight: 0.8,
  clearings: [[4000, 2000, 1100], ...REFUGE.map(([x, y]) => [x, y, 300]), [SOUTH[0], SOUTH[1], 450], [BRIDGE[0], BRIDGE[1] - 400, 350]],
  fields: [[3000, 1800, 520, 260], [5000, 1900, 520, 260, '#86803f']],
  grass: [[2400, 2100, 240, 110], [5600, 2000, 240, 110], [3300, 3200, 240, 110], [4800, 3150, 240, 110]],
};
